import React from 'react'
import { Link as LinkS} from 'react-scroll'
import {Link as LinkR} from 'react-router-dom'
import { Navbar, Nav, Container, Button } from 'react-bootstrap'
import { Parallax } from 'react-parallax'
import './styles.scss'
import ParallaxBg from '../../assets/Bg.jpg'
import { FaBars } from "react-icons/fa";

function Banner(props) {
    return (
        <Parallax bgImage={ParallaxBg} className="parallax">
            <Navbar className='Nav' fixed="top" expand="lg">
                <Container>
                    <Navbar.Brand style={{ color: '#03134e' }} className="NavLogo"><span>T</span>ech<span>S</span>eminal</Navbar.Brand>
                    <Navbar.Toggle className="toogle-btn" aria-controls="responsive-navbar-nav">
                        <FaBars />
                    </Navbar.Toggle>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ml-auto">
                            <Nav.Link as={LinkS} className="navLinks" smooth={true} duration={300} style={{ color: '#03134e' }} to="Services">Services</Nav.Link>
                            <Nav.Link as={LinkS} className="navLinks" smooth={true} duration={300} style={{ color: '#03134e' }} to="Our-Work">Projects</Nav.Link>
                            <Nav.Link as={LinkS} className="navLinks" smooth={true} duration={300} style={{ color: '#03134e' }} to="Moto">our-motto</Nav.Link>
                            <Nav.Link as={LinkS} className="navLinks" smooth={true} duration={300} style={{ color: '#03134e' }} to="Team">Team-members</Nav.Link>
                            <Nav.Link as={LinkS} className="navLinks" smooth={true} duration={300} style={{ color: '#03134e' }} to="Contact">Contact</Nav.Link>
                            {props.user ?
                            <Button as={LinkR} style={{ color: '#fff', borderRadius:'25px' }} to="/community">Community</Button>
                            :
                            <Button as={LinkS} smooth={true} duration={300} style={{ color: '#fff', borderRadius:'25px' }} to="Joinus">JOIN US</Button>
                            }
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <header>
                <p className="hello">welcome to TechSeminal</p>
                <p className="Title">
                    This is not about Ideas<br />
                    This is about making Ideas happen
                </p>
                <Button as={LinkR} to="/freelance" className="btn">Explore Freelance Service</Button>
            </header>
        </Parallax>
    )
}

export default Banner
